// Vendor imports
const _ = require('lodash')

function deferDispatch(dispatch) {

  function dispatchAction(action) {
    return (...args) => dispatch(action(...args))
  }

  function dispatchActionWithValue(action) {
    return event => dispatch(action(event.target.value))
  }

  function dispatchActionWithChecked(action) {
    return event => dispatch(action(event.target.checked))
  }

  function dispatchAuthRequiredAction(loggedInAction, loggedOutAction) {
    return function (...args) {
      dispatch(function (dispatch, getState) {
        const { user } = getState()
        if (user.loggedIn) {
          dispatch(loggedInAction(...args))
        } else {
          dispatch(loggedOutAction(...args))
        }
      })
    }
  }

  function dispatchRolloutRequiredAction(rolloutName, enabledAction, disabledAction) {
    return function (...args) {
      dispatch(function (dispatch, getState) {
        const { user } = getState()
        if (user.hasRollout(rolloutName)) {
          dispatch(enabledAction(...args))
        } else if (disabledAction) {
          dispatch(disabledAction(...args))
        }
      })
    }
  }

  function composableMapDispatchToProps(mapDispatchToProps) {
    if (_.isFunction(mapDispatchToProps)) {
      return mapDispatchToProps(dispatch)
    }
    if (_.isObject(mapDispatchToProps)) {
      return _.transform(mapDispatchToProps, (acc, value, key) => {
        acc[key] = dispatchAction(value)
      })
    }
  }

  return {
    composableMapDispatchToProps,
    dispatchAction,
    dispatchActionWithValue,
    dispatchActionWithChecked,
    dispatchAuthRequiredAction,
    dispatchRolloutRequiredAction
  }

}

module.exports = deferDispatch
